import React, { useEffect, useState } from 'react' // Import Link icon
import { CircleAlertIcon, Pencil, Trash2, ListOrdered, ChevronDown, Info, Settings, Link, MoreVertical, ChevronRight } from 'lucide-react'
import '../shared/AccordianStyle.css'
import { motion, AnimatePresence } from 'framer-motion'
import { CDropdown, CDropdownToggle, CDropdownMenu, CDropdownItem } from '@coreui/react'
import InfoModel from './InfoModel'
import Media from './Media'
const PhysicalExaminationAccordian = ({
  title,
  content,
  editAccordion,
  accordion,
  deleteAccordion,
  key,
  index,
  handleAddTitleDescription,
  itemData,
  setShowActiveFunctionality,
  handleAddEditEducationData,
  type = 'GE',
  headerDraggable = false,
  onHeaderDragStart,
  onHeaderDragOver,
  onHeaderDrop,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const [highlightedIndex, setHighlightedIndex] = useState(null)
  useEffect(() => {
    if (title == null) {
      setIsOpen(true)
    }
  }, [])

  const toggleAccordion = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div className="accordion-item w-full accordion-scope " style={{ borderRadius: '10px', border: `${isOpen ? '' : 'none'}` }}>
      <h2
        className="accordion-header border"
        draggable={headerDraggable}
        onDragStart={onHeaderDragStart}
        onDragOver={onHeaderDragOver}
        onDrop={onHeaderDrop}
        style={{
          borderRadius: '10px',
          transition: 'outline 0.2s ease-in-out',
          cursor: headerDraggable ? 'grab' : undefined,
        }}
      >
        <button
          className={`accordion-button ${!isOpen ? 'collapsed' : ''} d-flex justify-content-between align-items-center  `}
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseOne"
          onClick={toggleAccordion}
          style={{
            borderRadius: '10px',
            outline: isOpen ? (itemData?.type === 'option' ? '2px solid #2eb85c' : '2px solid #9da5b1') : 'none',
            transition: 'outline 0.2s ease-in-out',
            color: 'inherit',
          }}
        >
          <div className="d-flex align-items-center gap-1">
            {type == 'GE' ? <div style={{ maxWidth: '90%', maxHeight: '50px', overflow: 'auto' }}> {title}</div> : <div style={{ maxWidth: '90%', maxHeight: '50px', overflow: 'auto' }}> {title || ''}</div>}
            <div className="d-flex align-items-center gap-1 ms-1">
              <div>
                <Info
                  className={`pe-accordion-icon ${highlightedIndex === index ? 'highlighted' : ''}`}
                  strokeWidth={1.5}
                  onClick={() => {
                    handleAddTitleDescription(itemData)
                    setShowActiveFunctionality('description')
                  }}
                  size={20}
                  style={{
                    transition: 'all 0.3s ease-in-out',
                    color: highlightedIndex === index ? '#0d6efd' : 'var(--ui-text-primary)',
                    backgroundColor: highlightedIndex === index ? 'rgba(13, 110, 253, 0.2)' : '',
                    borderRadius: '50%',
                    width: '28px',
                    height: '28px',
                    padding: '3px',
                  }}
                />
              </div>

              <div
                className=""
                onClick={() => {
                  setShowActiveFunctionality('education'), handleAddEditEducationData(itemData)
                }}
              >
                <div className="d-flex justify-content-center align-items-center pe-accordion-badge" style={{ width: '22px', height: '22px', fontSize: '12px', border: '1.5px solid var(--ui-text-primary, #ffffff)', borderRadius: '100px', color: 'var(--ui-text-primary)' }}>
                  e
                </div>
              </div>
            </div>
          </div>

          <div>
            <span className="custom-icon ms-auto d-flex gap-2 align-items-center justify-content-center pe-accordion-action-icons">
              {editAccordion && <Pencil size={16} className="pe-accordion-icon" onClick={editAccordion} style={{ color: 'var(--ui-text-primary)', cursor: 'pointer' }} />}
              {deleteAccordion && <Trash2 size={18} strokeWidth={1.5} className="pe-accordion-icon" onClick={deleteAccordion} style={{ color: 'var(--ui-text-primary)', cursor: 'pointer' }} />}
              <ChevronRight size={22} strokeWidth={1.5} className="pe-accordion-icon" onClick={toggleAccordion} style={{ color: 'var(--ui-text-primary)', cursor: 'pointer', transform: `${isOpen ? 'rotate(270deg)' : 'rotate(90deg)'}`, transition: 'transform 0.3s ease-in-out' }} />
            </span>
          </div>
        </button>
      </h2>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div className="accordion-collapse" initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.3, ease: 'easeInOut' }} style={{ border: 'none' }}>
            <div className="accordion-body ">{content}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

export default PhysicalExaminationAccordian
